import React, { useEffect, useState } from 'react';

let push = () => {};
export function toast(msg, opts = {}) { push({ msg, ...opts }); }

export function Toaster() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    push = (item) => {
      const id = Math.random().toString(36).slice(2);
      setItems(s => [...s, { ...item, id }]);
      setTimeout(() => setItems(s => s.filter(x => x.id !== id)), item.duration || 3500);
    };
    return () => { push = () => {}; };
  }, []);
  return (
    <div className="toast-stack">
      {items.map(t => (
        <div key={t.id} className={`toast ${t.error ? 'error' : ''}`}>{t.msg}</div>
      ))}
    </div>
  );
}
